import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { EsquemaConexion } from '../components/TabConexiones/EsquemaConexion';
import { Suspensiones } from '../components/TabConexiones/Suspensiones';
import { Conexiones } from '../components/TabConexiones/Conexiones';


const dias = [
    { label: 'Domingo', value: 1 },
    { label: 'Lunes', value: 2 },
    { label: 'Martes', value: 3 },
    { label: 'Miércoles', value: 4 },
    { label: 'Jueves', value: 5 },
    { label: 'Viernes', value: 6 },
    { label: 'Sábado', value: 7 },
];

export const TabConexiones = ({
    allowedWrite,
    idEvaluacionSelected,
    idDelegacion,
    idPaciente,
    getContratos,
    evaluacionSelected,
    planCuidadoPoseeEsquema
}) => {

    const [poseeEsquema, setPoseeEsquema] = useState(planCuidadoPoseeEsquema);
    const [esquema, setEsquema] = useState([]);
    const [suspensiones, setSuspensiones] = useState([]);

    const handleAgregarSuspension = () => {
        toast('handleSave');
    }

    useEffect(() => {
        setPoseeEsquema(planCuidadoPoseeEsquema)
    }, [planCuidadoPoseeEsquema]);

    return (
        <>
            <EsquemaConexion
                allowedWrite={allowedWrite}
                idEvaluacionSelected={idEvaluacionSelected}
                dias={dias}
                poseeEsquema={poseeEsquema}
                esquema={esquema}
                setPoseeEsquema={setPoseeEsquema}
                setEsquema={setEsquema}
            />
            <Suspensiones
                handleAgregarSuspension={handleAgregarSuspension}
                allowedWrite={allowedWrite}
                idEvaluacionSelected={idEvaluacionSelected}
                idPaciente={idPaciente}
                idDelegacion={idDelegacion}
                getContratos={getContratos}
                setSuspensionesAux={setSuspensiones}
                modulo={evaluacionSelected?.modulo}
                fechaHastaContrato={evaluacionSelected?.fechaHasta}
            />
            <Conexiones
                idPaciente={idPaciente}
                allowedWrite={allowedWrite}
                idEvaluacionSelected={idEvaluacionSelected}
                esquema={esquema}
                poseeEsquema={poseeEsquema}
                dias={dias}
                getContratos={getContratos}
                estadoAsistencial={evaluacionSelected.estadoAsistencial}
                suspensiones={suspensiones}
                evaluacionSelected={evaluacionSelected}
            />
        </>
    )
};